import { TransactionFlag, TransactionType } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';
import { isType } from './isType';
import { hasFlag } from './hasFlag';

export const isCategorizable: TransactionPredicate = (transaction) =>
    hasFlag(TransactionFlag.IS_BAL_RELEVANT)(transaction) &&
    !isType(TransactionType.PREPAID_CARD)(transaction);
